<div class="root">
  <nav id="navigation">
    <div class="content" [ngClass]="isLoggedIn != true ? 'logout' : 'loggedin' ">
      <div class="left">
        <a class="ps-sm-0 ps-3 logo-link" routerLink="/">
          <img id="blueLogo" src="../../../../assets/images/enl-solutions-logo-new.png" />
          <!-- <img id="WhiteLogo" src="../../../../assets/images/WhiteLogo.png" style="display: none;"/> -->
        </a>

      </div>
      <div class="right">
        <div class="links">
          <!-- <div class="dropdown" #dropdownEl (mouseenter)="dropdownTl.play()" (mouseleave)="dropdownTl.reverse()">
            Port-to-Port

          <div class="dropdown-list">
            <a routerLink="#" *ngFor="let link of voyageFinderLinks" routerLink="{{link.href}}">{{link.title}}</a>
          </div>
          </div> -->
          <div class="navigation-link" *ngFor="let link of links;" #linkEl (mouseenter)="animateLink(linkEl)"
            (mouseleave)="animateLinkOut(linkEl)">
            <a routerLink="{{link.href}}">{{ link.title }}</a>
            <div class="underline"></div>
          </div>
          <div [hidden]="!isAdmin" class="navigation-link-no-underline admin-link" (mouseenter)="openAdminDropdown()">
            Admin
          </div>
          <div [hidden]="!isAdmin" class="admin-dropdown-container" (mouseleave)="closeAdminDropdown()">
            <div class="admin-dropdown">
              <a *ngFor="let link of adminLinks;" routerLink="{{link.href}}">{{link.title}}</a>
            </div>
          </div>
        </div>
        <button *ngIf="isLoggedIn != true" (click)="openLoginModal()"
          class="btn btn-outline-success btn-sign-in my-2 my-sm-0" type="submit">
          Sign In
        </button>
        <div [hidden]="!isLoggedIn" class="user-dropdown-container" (mouseleave)="closeUserDropdown();">
          <div class="user-avatar" (mouseenter)="openUserDropdown()">
            {{userNameShorthand}}
          </div>
          <div class="user-dropdown">
            <a class="user-dropdown-link" routerLink='/planselection'><i aria-hidden="true">
              </i>PLAN SELECTION</a>
            <a class="user-dropdown-link" routerLink='/trackingvoyage'><i aria-hidden="true">
              </i>Saved trackings</a>
              <a class="user-dropdown-link" routerLink='/myraterequest'><i aria-hidden="true">
              </i>My Rate requests</a>
            <a class="user-dropdown-link" *ngIf="isAdmin != true && isSubcription == 3"
              (click)="planSubcriptiont(isSubcription)"><i aria-hidden="true">
              </i>Subscribe</a>
            <a class="user-dropdown-link" *ngIf="isAdmin != true && isSubcription == 1"
              (click)="planSubcriptiont(isSubcription)"><i aria-hidden="true">
              </i>Unsubscribe</a>
            <a class="user-dropdown-link" (click)="signOut()"><i aria-hidden="true">
              </i>SIGN OUT</a>
          </div>
        </div>
      </div>
      <div class="hamburger pe-sm-0 pe-3" (click)="toggleMenu()">
        <div class="hamburger-slide first-slide"></div>
        <div class="hamburger-slide second-slide"></div>
        <div class="hamburger-slide last-slide"></div>
      </div>
    </div>
  </nav>
  <div class="menu-background"></div>
  <div class="menu-content">
    <!--
    <div class="mobile-navigation-link voyage-finder-link" (click)="toggleMobileDropdown()">
      Port-to-Port
      <img class="down-arrow" src="../../../../assets/images/svgs/down-chevron.svg" />
    </div>
    <div class="mobile-dropdown">
      <a class="mobile-dropdown-link" *ngFor="let link of voyageFinderLinks;" routerLink="{{link.href}}">{{link.title}}</a>
    </div>-->
    <div class="mobile-navigation-links-container">
      <div class="mobile-navigation-link" *ngFor="let link of links;">
        <a routerLink="{{link.href}}">{{ link.title }}</a>
      </div>
      <div class="mobile-navigation-link">
        <button *ngIf="isLoggedIn != true" (click)="openLoginModal()"
                class="mobile-navigation-link-signin" type="submit">
          Sign In
        </button>
      </div>
    </div>
  </div>
</div>
